export default function(update) {
  return new Array(update.length);
}



//////////////////
// WEBPACK FOOTER
// D:/glois.angular/~/d3-selection/src/selection/sparse.js
// module id = ../../../../d3-selection/src/selection/sparse.js
// module chunks = 4